export function extractYouTubeID(url) {
    try {
      // handle standard URL
      const urlObj = new URL(url);
      if (urlObj.hostname === "youtu.be") {
        return urlObj.pathname.slice(1);
      }
      if (urlObj.searchParams.has("v")) {
        return urlObj.searchParams.get("v");
      }
      // fallback: match /embed/ID
      const match = url.match(/embed\/([a-zA-Z0-9_-]{11})/);
      console.log("match", match);
      if (match) return match[1];
    } catch (e) {
      console.log("url", url);
      console.error("Invalid URL", e);
    }
    return null;
  }
  